import React from "react";
import myLogo from "../img/my-logo.png";
import { APP_NAME } from "../utils/constants";

const BlogCard = () => {
	return (
		<div className="w-full md:w-2/3 p-5 hover:shadow-2xl shadow-md mb-8 rounded-lg relative pb-12">
			<h1 className="text-xl sm:text-2xl font-bold">
				How to host a Next.js app in Production on an Ubuntu VPS
			</h1>
			<div className="flex gap-3 items-center">
				<img
					className="h-10 border border-black rounded-full contrast-150"
					src={myLogo}
					alt="myLogo"
				></img>
				<div className="sm:flex gap-5 items-center">
					<h4 className="font-normal text-base">{APP_NAME}</h4>
					<span className="hidden sm:inline text-xl opacity-45">
						|
					</span>
					<p className="opacity-80 text-sm">March 23, 2024</p>
				</div>
			</div>
			<p>
				Learn how to deploy a Next.js application in a production
				environment on an Ubuntu VPS with this comprehensive guide.
				Follow step-by-step instructions to set up NGINX, PM2, and
				configure your Next.js app for seamless hosting.
			</p>
			<button className="bg-orange-600 rounded-full px-4 py-1 text-white font-medium absolute bottom-1 left-4">
				Read More
			</button>
		</div>
	);
};

export default BlogCard;
